import { Component, Input, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import * as $ from 'jquery';

import { ProductService } from '../../services/product.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { DomSanitizer } from '@angular/platform-browser';
declare var document: any;
declare var window: any;
@Component({
  selector: 'app-view-cms-content',
  templateUrl: './view-cms-content.component.html',
  styleUrls: ['./view-cms-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewCmsContentComponent implements AfterViewInit {
  @Input()
  cmsContentUrl?: string;
  @Input()
  cmsContentId?: string;
  private ENV : any ;
  constructor(
    private productService: ProductService,
    private UTS: UtilitiesService,
    private sanitizer: DomSanitizer
  ) {}
  ngAfterViewInit(): void {
    if (this.cmsContentUrl) {
      setTimeout(() => {
        
      this.productService
      .getCMSContent(this.cmsContentUrl, 'GET')
      .subscribe((res: any) => {
        let response = res.htmlSrc.toString();
        response = this.sanitizer.bypassSecurityTrustHtml(response);
        response = response.changingThisBreaksApplicationSecurity;
        // document.getElementById(this.cmsContentId).classList.add("aem-spa-wrap");
        document.getElementById(this.cmsContentId).innerHTML = '';
        document.getElementById(this.cmsContentId).innerHTML = response;
        const currentLang = $('#mainIndex').attr('lang');
        $('#language').on('click', (e: any) => {
          e.preventDefault();
          if (window.location.href.indexOf('/b2c/') > 0) {
            if (currentLang && currentLang.toString().toLowerCase() == 'en')
              window.location.href = this.updateQueryStringParam('AR');
            else if (
              currentLang &&
              currentLang.toString().toLowerCase() == 'ar'
            )
              window.location.href = this.updateQueryStringParam('EN');
          }
        });
        setTimeout(() => {
          this.ENV = this.UTS.getENV();
          if(this.ENV != "mobile"){
            window.DYNAMIC_COMPONENTS.loadAll();
          }
        }, 1500);
      },(e)=>{
        
      });
      }, 1500);
    }
  }

  private updateQueryStringParam(value: string): string {
    const key = 'locale';
    var keyRegex = new RegExp(`([\?&])${key}[^&]*`);
    const baseUrl = `${location.protocol}//${location.host}${location.pathname}`;
    const urlQueryString = document.location.search;
    const newParam = `${key}=${value}`;
    if (urlQueryString) {
      if (urlQueryString.match(keyRegex) !== null)
        return `${baseUrl}${urlQueryString.replace(keyRegex, '$1' + newParam)}`;
      else return `${urlQueryString}&${newParam}`;
    }
    return `${baseUrl}${newParam}`;
  }
}
